import React, { useEffect, useRef } from 'react';
import { defineCustomElements } from '@om-design-system/web-components/loader';

const OmCard = React.forwardRef(({
  children,
  className,
  style,
  onClick,
  ...props
}, ref) => {
  const elementRef = useRef(null);

  useEffect(() => {
    defineCustomElements();
  }, []);

  useEffect(() => {
    const element = elementRef.current;
    if (!element || !onClick) return;

    const handleClick = (event) => {
      if (onClick) {
        onClick(event);
      }
    };

    element.addEventListener('click', handleClick);

    return () => {
      element.removeEventListener('click', handleClick);
    };
  }, [onClick]);

  return (
    <omk-card
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      className={className}
      style={style}
      {...props}
    >
      {children}
    </omk-card>
  );
});

OmCard.displayName = 'OmCard';

export default OmCard;
